import React, { memo, useState } from "react";
import { Handle, Position, NodeResizer, useReactFlow } from "@xyflow/react";
import "./ResizableNodeSelected.css";

const ResizableNodeSelected = ({ data, id, selected }: any) => {
  const { setNodes } = useReactFlow();

  // Estado para armazenar as dimensões do nó
  const [width, setWidth] = useState(data.width || 64);
  const [height, setHeight] = useState(data.height || 64);

  // Função chamada ao redimensionar o nó
  const handleResize = (
    event: any,
    size: { width: number; height: number }
  ) => {
    setWidth(size.width);
    setHeight(size.height);

    setNodes((nodes) =>
      nodes.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                width: size.width,
                height: size.height,
              },
            }
          : node
      )
    );
  };

  return (
    <div
      style={{
        position: "relative",
        width: `${width}px`,
        height: `${height + 20}px`, // +20 para espaço do nome
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      {/* Resizer que permite redimensionamento do nó */}
      <NodeResizer
        color="#ff0071"
        isVisible={selected}
        minWidth={32}
        minHeight={32}
        onResize={handleResize}
      />

      {/* Handles para conexões */}
      <Handle type="source" position={Position.Left} isConnectable id="left" />
      <Handle type="target" position={Position.Left} isConnectable id="left" />

      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable
        id="bottom"
      />
      <Handle
        type="target"
        position={Position.Bottom}
        isConnectable
        id="bottom"
      />

      <Handle type="source" position={Position.Top} isConnectable id="top" />
      <Handle type="target" position={Position.Top} isConnectable id="top" />

      <Handle
        type="source"
        position={Position.Right}
        isConnectable
        id="right"
      />
      <Handle
        type="target"
        position={Position.Right}
        isConnectable
        id="right"
      />

      {/* Imagem do nó */}
      {data.image && (
        <div
          style={{
            backgroundImage: `url(${data.image})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            width: `${width}px`,
            height: `${height}px`,
          }}
        />
      )}

      {/* Nome abaixo da imagem */}
      <div
        style={{
          textAlign: "center",
          fontSize: "12px",
          fontWeight: "bold",
          marginTop: "4px",
          maxWidth: `${width}px`,
          wordWrap: "break-word",
        }}
      >
        {data.label}
      </div>

      {data.falha && <div className="falha-indicador-resizable">⚠️</div>}
      {data.falhaAtraso && <div className="falha-indicador-resizable">⏳</div>}
    </div>
  );
};

export default memo(ResizableNodeSelected);
